import { searchNestedObject } from "./helpers";

export const filterBySearch = <T>(data: T[], searchValue: string) => {
  return data?.filter(datum => searchNestedObject(datum, searchValue)) || [];
};
